import { Box, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';

import { ModalContentContainer } from '@/components';
import { Modals } from '@/constants';
import { uiActions } from '@/store';

import { AppModal } from '../AppModal';

export const ConcurrentSessionModal = () => {
  const dispatch = useDispatch();

  const onClose = () => dispatch(uiActions.closeActiveModal());

  return (
    <AppModal modalName={Modals.CONCURRENT_SESSION_PROHIBITED}>
      <ModalContentContainer onModalClose={onClose}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography variant="h3">
            You&apos;re already listening somewhere else
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.main' }}>
            It looks like you&apos;re currently listening on another device or
            browser window. For compliance reasons, your account can only have
            one active session at a time.
          </Typography>
        </Box>
      </ModalContentContainer>
    </AppModal>
  );
};
